import { Collapse, Skeleton } from 'antd';
import type { BtlApplication } from 'api/btlApplicationForm/types';
import { ApplicantsSummary } from 'pages/BtlApplicationFormPage/CaseSummary/ApplicantsSummary';
import { FinancingAndPropertySummary } from 'pages/BtlApplicationFormPage/CaseSummary/FinancingAndPropertySummary';
import { useIntl } from 'react-intl';

interface CaseOverviewProps {
  case?: BtlApplication;
  isLoading: boolean;
}

export function CaseOverview({ case: caseData, isLoading }: CaseOverviewProps) {
  const { formatMessage } = useIntl();

  const sections = [
    {
      id: 'FINANCING_AND_PROPERTY',
      Content: () => <FinancingAndPropertySummary data={caseData} variant='oo' />,
      sectionTitle: formatMessage({ id: 'btlApplicationForm.FINANCING_AND_PROPERTY.label' }),
    },
    {
      id: 'APPLICANTS',
      Content: () => <ApplicantsSummary data={caseData} />,
      sectionTitle: formatMessage({ id: 'btlApplicationForm.APPLICANTS.label' }),
    },
  ];

  return (
    <Collapse defaultActiveKey={['0', '1']}>
      {sections.map(({ id, Content, sectionTitle }, index) => (
        <Collapse.Panel header={sectionTitle} key={index} className={'[&_.ant-collapse-header]:!items-center'}>
          <Skeleton loading={isLoading} active>
            <Content key={id} />
          </Skeleton>
        </Collapse.Panel>
      ))}
    </Collapse>
  );
}
